import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import {
  addDays,
  addWeeks,
  addMonths,
  startOfMonth,
  startOfYear,
  getDate,
  differenceInWeeks,
  differenceInDays,
  differenceInMonths,
  format,
  isSameWeek,
} from 'ag-common/facades'
import {CalendarConfig} from '#tools/calendarConfig'

const CalendarHeaderMonthly = ({
  date,
  startOfCalendar,
  endOfCalendar,
  calendarType,
  setDate = null,
  setCalendarType = null,
  isDashboardView = false,
  handleClickWeek,
  handleClickYear,
  scrollLeftControl: ScrollLeftControl = () => null,
  scrollRightControl: ScrollRightControl = () => null,
  calendarTypeButtons: CalendarTypeButtons = () => null,
}) => {
  const numberOfWeeks = differenceInWeeks(endOfCalendar, startOfCalendar) + 1
  const numberOfDays = differenceInDays(endOfCalendar, startOfCalendar) + 1
  const numberOfMonths = differenceInMonths(endOfCalendar, startOfCalendar)
  const showFirstMonth = !isDashboardView || getDate(date) <= 15

  const {getBorderColor} = CalendarConfig[calendarType]

  const gridColumnOffset = isDashboardView ? 0 : 1
  const gridTemplateColumns = isDashboardView
    ? `repeat(${numberOfDays}, 1fr)`
    : `284px repeat(${numberOfDays}, 1fr) 40px`

  return (
    <div className="calendar__header calendar__header--monthly" style={{gridTemplateColumns}}>
      {showFirstMonth && (
        <button
          type="button"
          className="calendar__current-month-button"
          disabled={!setCalendarType || !setDate}
          onClick={() => handleClickYear(startOfYear(date))}
          style={{
            gridColumn: `${differenceInDays(date, startOfCalendar) + 1 + gridColumnOffset} / ${-1 - gridColumnOffset}`,
          }}>
          {format(date, `MMMM yyyy`)}
        </button>
      )}

      {isDashboardView &&
        _.times(numberOfMonths, n => (
          <button
            key={`${calendarType}-${addDays(startOfCalendar, n + 1)}`}
            type="button"
            className="calendar__current-month-button"
            disabled={!setCalendarType || !setDate}
            onClick={() => handleClickYear(startOfYear(startOfMonth(addMonths(date, n + 1))))}
            style={{
              gridColumn: `${
                differenceInDays(startOfMonth(addMonths(date, n + 1)), startOfCalendar) + 1 + gridColumnOffset
              } / ${-1 - gridColumnOffset}`,
            }}>
            {format(startOfMonth(addMonths(date, n + 1)), `MMMM yyyy`)}
          </button>
        ))}

      {!isDashboardView && (
        <div className="calendar__controls calendar__controls--left">
          <CalendarTypeButtons />
          <ScrollLeftControl />
        </div>
      )}
      {_.times(numberOfDays, n => (
        <div
          key={`${calendarType}-${addDays(startOfCalendar, n)}`}
          data-date={addDays(startOfCalendar, n)}
          className="calendar__placeholder"
          style={{gridColumn: n + 1 + gridColumnOffset, borderColor: getBorderColor(addDays(startOfCalendar, n))}}
        />
      ))}
      {_.times(numberOfWeeks, n => {
        const currentWeekClass = isSameWeek(new Date(), addWeeks(startOfCalendar, n)) ? 'calendar__week--current' : ''
        return (
          <div
            key={addWeeks(startOfCalendar, n)}
            data-date={addWeeks(startOfCalendar, n)}
            className={`calendar__week ${currentWeekClass}`}
            style={{gridColumn: `${n * 7 + 1 + gridColumnOffset} / span 7`}}>
            <button
              type="button"
              className="calendar__kw__header"
              disabled={!setCalendarType || !setDate}
              onClick={() => handleClickWeek(addWeeks(startOfCalendar, n))}>
              {`KW ${format(addWeeks(startOfCalendar, n), 'ww')}`}
            </button>
          </div>
        )
      })}
      {!isDashboardView && (
        <div className="calendar__controls calendar__controls--right">
          <ScrollRightControl />
        </div>
      )}
    </div>
  )
}

CalendarHeaderMonthly.propTypes = {
  startOfCalendar: PropTypes.object.isRequired,
  endOfCalendar: PropTypes.object.isRequired,
  setCalendarType: PropTypes.func.isRequired,
  scrollLeftControl: PropTypes.func,
  scrollRightControl: PropTypes.func,
  calendarTypeButtons: PropTypes.func,
  handleClickWeek: PropTypes.func,
  handleClickYear: PropTypes.func,
}

export default CalendarHeaderMonthly
